import { Alert, Button, message, Modal, Space, Spin, Tabs } from "antd";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AdvanceAccountabilityFormExpenditureTable from "./AdvanceAccountabilityFormExpenditureTable";
import AdvanceAccountabilityFormOtherDetails from "./AdvanceAccountabilityFormOtherDetails";
import appConfig from "../../../../config/config.json";
import generateAdvanceAccounatabilityFormPdf from "../../../../config/services/advanceAccountabilityFormPdf";
import generateActivityReportPdf from "../../../../config/services/activityReportPdf";
import { getCurrency } from "../../../../config/helpers/app/numberFormater";
import { rejectionsActions } from "../../../../config/actions/rejections/rejections.actions";
import RecordStatusButtons from "../../../common/FormStatusButtons";
import { useReportingTemplateStore } from "../../../../config/stores";
import advanceAccountabilityFormThunks from "../../../../config/thunks/finance/advanceAccountabilityForm/advanceAccountabilityForm.thunks";
import ActivityReportingTemplate from "../reportingTemplate/ActivityReportingTemplate";
import ActionPoints from "../ActionPoints/ActionPoints";
import PrintActivityReportingTemplate from "../reportingTemplate/PrintActivityReportingTemplate";
import { useReactToPrint } from "react-to-print";
import { isEmpty } from "lodash";
import AppButton from "../../../common/AppButton";
import {
  AiOutlineDownload,
  AiOutlinePrinter,
  AiOutlineReload,
} from "react-icons/ai";

const AdvanceAccountabilityFormDetails = ({
  visible,
  handleApprove,
  handleCheck,
  handleSubmit,
  handleViewDetails,
  handleOpenEditModal,
  handleCloseModal,
  handleOpenAddExpenditureModal,
  handleRefresh,
  handleDeleteExpenditure,
  handleOpenAddDocument,
  handleRejection,
}) => {
  const reportingTemplateStore = useReportingTemplateStore();
  const {
    advanceAccountabilityFormsDetailsLoading,
    advanceAccountabilityFormsDetailsSuccess,
    advanceAccountabilityFormsDetailsError,
    advanceAccountabilityFormsDetails,
    submitAdvanceAccountabilityFormsLoading,
    submitAdvanceAccountabilityFormsSuccess,
    submitAdvanceAccountabilityFormsError,
    submitAdvanceAccountabilityFormsMessage,
    approveAdvanceAccountabilityFormsLoading,
    approveAdvanceAccountabilityFormsSuccess,
    approveAdvanceAccountabilityFormsError,
    approveAdvanceAccountabilityFormsMessage,
    checkAdvanceAccountabilityFormsLoading,
    checkAdvanceAccountabilityFormsSuccess,
    checkAdvanceAccountabilityFormsError,
    checkAdvanceAccountabilityFormsMessage,
    advanceAccountabilityFormsExpenditure,
  } = useSelector((state) => state.advanceAccountabilityFormsState);
  const currency = getCurrency(
    advanceAccountabilityFormsDetails?.projectDetails,
    "approved_budget"
  );
  const dispatch = useDispatch();
  const refreshData = () => handleRefresh(advanceAccountabilityFormsDetails.id);
  const submit = () => handleSubmit(advanceAccountabilityFormsDetails.id);
  const approve = () => handleApprove(advanceAccountabilityFormsDetails.id);
  const check = () => handleCheck(advanceAccountabilityFormsDetails.id);
  const exportRecord = () => {
    advanceAccountabilityFormsDetails.status === appConfig.status.approved
      ? generateAdvanceAccounatabilityFormPdf(
          advanceAccountabilityFormsDetails,
          currency,
          advanceAccountabilityFormsExpenditure
        )
      : message.info("The Payment Voucher has not yet been approved");
  };
  const reject = () => {
    dispatch(
      rejectionsActions.toggleRejectionsModal({
        visible: true,
        data: {
          user_to_id: advanceAccountabilityFormsDetails?.created_by,
          item_application: "Payment Vouchers",
          item_id: advanceAccountabilityFormsDetails?.id,
          itemName: `Payment Voucher ${advanceAccountabilityFormsDetails.id}`,
        },
      })
    );
  };
  /* use effect */
  useEffect(() => {
    if (
      submitAdvanceAccountabilityFormsMessage &&
      submitAdvanceAccountabilityFormsSuccess
    )
      message.success(submitAdvanceAccountabilityFormsMessage);
    else if (
      !submitAdvanceAccountabilityFormsSuccess &&
      submitAdvanceAccountabilityFormsError
    )
      message.error(submitAdvanceAccountabilityFormsError);
    //approve
    if (
      approveAdvanceAccountabilityFormsSuccess &&
      approveAdvanceAccountabilityFormsMessage
    )
      message.success(approveAdvanceAccountabilityFormsMessage);
    else if (
      !approveAdvanceAccountabilityFormsSuccess &&
      approveAdvanceAccountabilityFormsError
    )
      message.error(approveAdvanceAccountabilityFormsError);
    //check
    if (
      checkAdvanceAccountabilityFormsSuccess &&
      checkAdvanceAccountabilityFormsMessage
    )
      message.success(checkAdvanceAccountabilityFormsMessage);
    else if (
      !checkAdvanceAccountabilityFormsSuccess &&
      checkAdvanceAccountabilityFormsError
    )
      message.error(checkAdvanceAccountabilityFormsError);
  }, [
    submitAdvanceAccountabilityFormsSuccess,
    submitAdvanceAccountabilityFormsMessage,
    submitAdvanceAccountabilityFormsError,
    approveAdvanceAccountabilityFormsSuccess,
    approveAdvanceAccountabilityFormsMessage,
    approveAdvanceAccountabilityFormsError,
    checkAdvanceAccountabilityFormsSuccess,
    checkAdvanceAccountabilityFormsMessage,
    checkAdvanceAccountabilityFormsError,
  ]);

  const reportingTemplate = useMemo(() => {
    return advanceAccountabilityFormsDetails.reportingTemplate || {};
  }, [advanceAccountabilityFormsDetails.reportingTemplate]);

  const reloadPaymentVoucher = () => {
    dispatch(
      advanceAccountabilityFormThunks.getAdvanceAccountabilityFormDetails(
        advanceAccountabilityFormsDetails.id
      )
    );
  };

  const contentRef = useRef();

  const handlePrint = useReactToPrint({
    contentRef,
    documentTitle: "ACTIVITY REPORT",
  });

  const [downloading, setDownloading] = useState(false);
  const onDownload = async () => {
    setDownloading(true);
    try {
      await generateActivityReportPdf(
        advanceAccountabilityFormsDetails,
        advanceAccountabilityFormsExpenditure
      );
    } catch {
      message.error("Unable to generate the activity report PDF");
    } finally {
      setDownloading(false);
    }
  };

  const onPrint = () => {
    setTimeout(() => {
      handlePrint();
    }, [10]);
  };
  return (
    <div>
      <Modal
        width={1200}
        onCancel={() => handleCloseModal(false)}
        open={visible}
        footer={[
          advanceAccountabilityFormsDetails.status !==
            appConfig.status.approved && (
            <Space className="mx-2">
              {advanceAccountabilityFormsDetails.submitted ? (
                <Space>
                  <Button
                    onClick={approve}
                    loading={approveAdvanceAccountabilityFormsLoading}
                    type="primary"
                  >
                    Approve
                  </Button>
                  {advanceAccountabilityFormsDetails.status !==
                    appConfig.status.checked && (
                    <Button
                      onClick={check}
                      loading={checkAdvanceAccountabilityFormsLoading}
                    >
                      Check
                    </Button>
                  )}
                  <Button onClick={reject} danger>
                    Reject
                  </Button>
                </Space>
              ) : (
                <Button
                  onClick={submit}
                  loading={submitAdvanceAccountabilityFormsLoading}
                  className="bg-light mx-2"
                  type="dashed"
                  disabled={
                    !advanceAccountabilityFormsDetails.reportingTemplate &&
                    advanceAccountabilityFormsDetails?.budgetLineDetails
                      ?.requires_concept_note
                  }
                >
                  Submit Payment Voucher
                </Button>
              )}
            </Space>
          ),
          advanceAccountabilityFormsDetails?.status !==
            appConfig.status.approved && (
            <Button onClick={() => handleOpenAddDocument(true)}>
              Add Document
            </Button>
          ),
          <Space>
            {advanceAccountabilityFormsDetails?.reportingTemplate?.status !==
              appConfig.status.approved && (
              <RecordStatusButtons
                requiresSubmitted
                submitText="Submit Activity Report"
                checkText="Review/Check Activity Report"
                approveText="Approve Activity Report"
                data={reportingTemplate}
                storeActions={{
                  approve: async (id) => {
                    await reportingTemplateStore.approveReportingTemplate(id);
                    reloadPaymentVoucher();
                  },
                  approving: reportingTemplateStore.approvingReportingTemplate,
                  submit: async (id) => {
                    await reportingTemplateStore.submitReportingTemplate(id);
                    reloadPaymentVoucher();
                  },
                  submitting:
                    reportingTemplateStore.submittingReportingTemplate,
                  check: async (id) => {
                    await reportingTemplateStore.checkReportingTemplate(id);
                    reloadPaymentVoucher();
                  },
                  checking: reportingTemplateStore.checkingTemplate,
                  undoingApproval:
                    reportingTemplateStore.undoingReportTemplateApproval,
                  undoApprove: async (id) => {
                    await reportingTemplateStore.undoApproval(id);
                    reloadPaymentVoucher();
                  },
                }}
              />
            )}
          </Space>,
        ]}
        title="PAYMENT VOUCHER DETAILS"
      >
        {advanceAccountabilityFormsDetailsLoading && (
          <div className="d-flex justify-content-center ">
            <Spin size="large" />
          </div>
        )}
        <div>
          {!advanceAccountabilityFormsDetailsSuccess ? (
            <Alert
              message={advanceAccountabilityFormsDetailsError}
              showIcon
              type="error"
            />
          ) : (
            <div>
              <Tabs
                tabBarStyle={{
                  marginBottom: 5,
                }}
                tabBarExtraContent={
                  <Space>
                    <AppButton
                      type="dashed"
                      iconBefore={<AiOutlineReload />}
                      text="RELOAD"
                      onClick={refreshData}
                    />
                    <AppButton
                      iconBefore={<AiOutlinePrinter />}
                      text="PRINT ACTIVITY REPORT"
                      type="default"
                      onClick={onPrint}
                    />
                    <AppButton
                      iconBefore={<AiOutlineDownload />}
                      text="DOWNLOAD ACTIVITY REPORT"
                      loading={downloading}
                      loadingText="DOWNLOADING..."
                      type="default"
                      disabled={isEmpty(reportingTemplate)}
                      onClick={onDownload}
                    />
                  </Space>
                }
                items={[
                  {
                    key: "actual-expenditure",
                    label: "ACTUAL EXPENDITURE",
                    children: (
                      <AdvanceAccountabilityFormExpenditureTable
                        handleExportRecords={exportRecord}
                        handleViewDetails={handleViewDetails}
                        handleOpenEditModal={handleOpenEditModal}
                        handleDelete={handleDeleteExpenditure}
                        handleRefreshTable={refreshData}
                        handleOpenAddModal={handleOpenAddExpenditureModal}
                      />
                    ),
                  },
                  {
                    label: "ACTIVITY REPORT",
                    key: "reporting-templates",
                    children: <ActivityReportingTemplate />,
                  },
                  {
                    label: "ACTION POINTS",
                    key: "action-points",
                    disabled: !reportingTemplate,
                    children: (
                      <ActionPoints reportingTemplate={reportingTemplate} />
                    ),
                  },
                  {
                    key: "payment-voucher-details",
                    label: "PAYMENT VOUCHER DETAILS",
                    children: (
                      <AdvanceAccountabilityFormOtherDetails
                        data={advanceAccountabilityFormsDetails}
                      />
                    ),
                  },
                ]}
              />
            </div>
          )}
        </div>
        <div className="d-none">
          <div className="p-2 border m-2" ref={contentRef}>
            <PrintActivityReportingTemplate />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AdvanceAccountabilityFormDetails;
